import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import store from 'store';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';

import { Ajax } from '../components/Ajax';
import { ApiUrl, StoreKeys } from '../project/Defines';
import Popups from '../components/Popup';
import Menu from './Navigation/Menu';
import Loader from '../Shared/Loader';
import { logout } from '../store/actions/index.js';

/**
 * The layout component specifies the site layout, top menu based on login state and active states of top menu items
 * @param {object} props  { isLoggedIn, popups, culture, role, etc.}
 */
function Layout(props) {
    const { i18n } = useTranslation();

    useEffect(() => {
        message.config({
            top: 100,
            duration: 4,
        });

        const check = function () {
            if (props.isLoggedIn) {
                let exptime = store.get(StoreKeys.ExpireTime);

                if (!exptime || exptime < new Date()) {
                    Ajax.post({
                        url: ApiUrl.AccountCheck,
                        data: {},
                        success: function (response) {
                            if (response) {
                                store.set(StoreKeys.ExpireTime, (new Date()).setMinutes((new Date()).getMinutes() + 1));
                            }
                            
                            if(response?.redirectUrl === "/login"){
                                /** // store.set(StoreKeys.LoggedIn, false);
                                //history.push('/login'); */
                                props.dispatch(logout({
                                    isLoggedIn: false,
                                    userToken: '',
                                    userName: null,
                                    networkCode: null,
                                    role: null
                                }));
                            }
                        }
                    })
                }
            }
        }
        const timer = setInterval(check, 6e4/10);
        check();
        return () => {
            clearInterval(timer)
        }
    }, [props.isLoggedIn]); /*eslint-disable-line react-hooks/exhaustive-deps*/

    return (
        <>
            {
                (//props.isLoggedIn && !Project.skipHeader(location) &&
                    <view key={i18n.language}>
                        <Menu 
                            role={props.role}
                            culture={props.culture}
                            networkCode={props.networkCode}
                        />
                        <Popups />
                        <view>
                            <Popups fullScreen />
                        {
                            props.children
                        }


                        </view>
                        <Loader />
                    </view>
                )
                || props.children
            }
        </>
    );
}

Layout.propTypes = {
    isLoggedIn: PropTypes.bool.isRequired,
    popups: PropTypes.array,
    culture: PropTypes.string,
    role: PropTypes.string,
    networkCode: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired
};

export default connect(state => ({
    isLoggedIn: state.isLoggedIn,
    popups: state.popups,
    culture: state.culture,
    role: state.role
}))(withRouter(Layout));